export const GearIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <g>
        <path d="M9.37594 3.75C9.37594 2.23122 10.6072 1 12.1259 1V1C13.6447 1 14.8759 2.23122 14.8759 3.75V4.21944C15.0733 4.28919 15.2672 4.36624 15.4573 4.45027L16.0464 3.86124C17.1203 2.7873 18.8615 2.7873 19.9354 3.86124V3.86124C21.0094 4.93518 21.0094 6.67639 19.9354 7.75033L19.4626 8.22317C19.6328 8.55311 19.7814 8.89601 19.9065 9.25H20.25C21.7688 9.25 23 10.4812 23 12V12C23 13.5188 21.7688 14.75 20.25 14.75H19.9065C19.7984 15.0559 19.6727 15.3535 19.5307 15.6417L19.9355 16.0464C21.0094 17.1203 21.0094 18.8615 19.9355 19.9355V19.9355C18.8615 21.0094 17.1203 21.0094 16.0464 19.9355L15.5972 19.4863C15.3626 19.5953 15.1219 19.6936 14.8759 19.7806V20.25C14.8759 21.7688 13.6447 23 12.1259 23V23C10.6072 23 9.37594 21.7688 9.37594 20.25V19.7806C9.02195 19.6554 8.67905 19.5069 8.34911 19.3367L7.75029 19.9355C6.67635 21.0094 4.93515 21.0094 3.8612 19.9355V19.9355C2.78726 18.8615 2.78726 17.1203 3.8612 16.0464L4.57621 15.3314C4.49219 15.1413 4.41514 14.9474 4.34538 14.75H3.75C2.23122 14.75 1 13.5188 1 12V12C1 10.4812 2.23122 9.25 3.75 9.25H4.34538C4.43233 9.00401 4.53061 8.76337 4.6396 8.52872L3.86121 7.75033C2.78727 6.67639 2.78727 4.93518 3.86121 3.86124V3.86124C4.93515 2.7873 6.67636 2.7873 7.7503 3.86124L8.48425 4.5952C8.7724 4.45322 9.07003 4.32757 9.37594 4.21944V3.75Z" />
        <circle cx="12" cy="12" r="3" />
      </g>
    </svg>
  );
};
